import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, ViewEncapsulation } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { StoryState } from 'src/app/story/state/story.state';
import { Observable, Subject } from 'rxjs';
import { StoryModel } from 'src/app/story/models/story.model';
import { ChapterModel } from 'src/app/story/models/chapter.model';
import { EditState } from '../../state/edit.state';
import { 
  PreviousChapter,
  NextChapter,
  DuplicateChapter} from 'src/app/story/state/chapters/story.chapters.actions';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit-chapter-pagination',
  templateUrl: './edit-chapter-pagination.component.html',
  styleUrls: ['./edit-chapter-pagination.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class EditChapterPaginationComponent implements OnInit, OnDestroy {
  @Select(StoryState.getStory)
  story$: Observable<StoryModel>;

  @Select(StoryChaptersState.getSelectedChapter)
  selectedChapter$: Observable<ChapterModel>;

  @Select(StoryChaptersState.getSelectedChapterIndex)
  selectedChapterIndex$: Observable<number>;

  @Select(StoryChaptersState.getStoryChapters)
  chapters$: Observable<ChapterModel[]>;

  private ngUnsubscribe = new Subject();

  chapterIndex: number;

  constructor(
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.selectedChapterIndex$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(chapterIndex => {
        this.chapterIndex = chapterIndex;
        this.changeDetectorRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handlePreviousClick() {
    this.store.dispatch(new PreviousChapter());
  }

  handleNextClick() {
    this.store.dispatch(new NextChapter());
  }
}
